import { cn } from 'utils/className';

interface RadioDotProps {
  checked: boolean;
  className?: string;
}

/**
 * Purely visual radio indicator (the real selection semantics live on the
 * parent `role="radio"` element). Matches the Figma 16px dot: neutral ring when
 * idle, emphasis ring + filled center when checked.
 */
export const RadioDot = ({
  checked,
  className: propsClassName,
}: RadioDotProps) => {
  const className = cn(
    'flex size-4 shrink-0 items-center justify-center rounded-full border bg-fill-input-neutral-idle transition-colors',
    checked
      ? 'border-border-input-emphasis-active'
      : 'border-border-input-neutral-idle',
    propsClassName,
  );

  return (
    <span className={className} aria-hidden="true">
      {checked && (
        <span className="size-2.5 rounded-full bg-icon-input-emphasis-active" />
      )}
    </span>
  );
};
